'use strict';

angular.module('amexReconciliationApp')
  .service('AccountingLineBillingCycleRepository', function ($resource) {
    var self = this;

    self.findSummaries = function () {
      var resource = $resource('/api/v1/accountingLineBillingCycles/search/findSummaries', {}, {
        getAccountingLines: { method: 'get', isArray: true }
      });

      return resource.getAccountingLines().$promise;
    };

    self.findAll = function (siteNumber, linkKey, concatValue) {

      var params = {
        siteNumber: siteNumber,
        linkKey: linkKey,
        concatValue: concatValue
      };

      var resource = $resource('/api/v1/accountingLineBillingCycles/search/findAll', {}, {
        getAccountingLines: { method: 'get', isArray: true }
      });

      return resource.getAccountingLines(params).$promise;
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/repositories/AccountingLineBillingCycleRepository.js
// module id = 599
// module chunks = 0